import { ThemedAccentIcon } from './ThemedAccentIcon';
import { ThemedBodyText } from './ThemedBodyText';
import { ThemedBreadcrumbs } from './ThemedBreadcrumbs';
import { ThemedCheckbox } from './ThemedCheckbox';
import { ThemedDeleteButton } from './ThemedDeleteButton';
import { ThemedDeprecatedSegmentedControl } from './ThemedDeprecatedSegmentedControl';
import { ThemedDialog } from './ThemedDialog';
import { ThemedFormField } from './ThemedFormField';
import { ThemedHeading } from './ThemedHeading';
import { ThemedHyperlink } from './ThemedHyperlink';
import { ThemedLabel } from './ThemedLabel';
import { ThemedMenu } from './ThemedMenu';
import { ThemedModal } from './ThemedModal';
import { ThemedOverflowTooltip } from './ThemedOverflowTooltip';
import { ThemedPill } from './ThemedPill';
import { ThemedPopup } from './ThemedPopup';
import { ThemedPrimaryButton } from './ThemedPrimaryButton';
import { ThemedSecondaryButton } from './ThemedSecondaryButton';
import { ThemedSegmentedControl } from './ThemedSegmentedControl';
import { ThemedSidePanel } from './ThemedSidePanel';
import { ThemedSkeleton } from './ThemedSkeleton';
import { ThemedSubtext } from './ThemedSubtext';
import { ThemedSystemIcon } from './ThemedSystemIcon';
import { ThemedTabs } from './ThemedTabs';
import { ThemedTertiaryButton } from './ThemedTertiaryButton';
import { ThemedTextArea } from './ThemedTextArea';
import { ThemedTextInput } from './ThemedTextInput';
import { ThemedToast } from './ThemedToast';
import { ThemedToolbarIconButton } from './ThemedToolbarIconButton';
import { ThemedTooltip } from './ThemedTooltip';

export const Canvas = {
  TextArea: ThemedTextArea,
  FormField: ThemedFormField,
  PrimaryButton: ThemedPrimaryButton,
  DeleteButton: ThemedDeleteButton,
  SecondaryButton: ThemedSecondaryButton,
  TertiaryButton: ThemedTertiaryButton,
  TextInput: ThemedTextInput,
  SystemIcon: ThemedSystemIcon,
  Heading: ThemedHeading,
  BodyText: ThemedBodyText,
  Subtext: ThemedSubtext,
  AccentIcon: ThemedAccentIcon,
  Breadcrumbs: ThemedBreadcrumbs,
  ToolbarIconButton: ThemedToolbarIconButton,
  SidePanel: ThemedSidePanel,
  Modal: ThemedModal,
  Menu: ThemedMenu,
  Tabs: ThemedTabs,
  Toast: ThemedToast,
  Checkbox: ThemedCheckbox,
  Popup: ThemedPopup,
  SegmentedControl: ThemedSegmentedControl,
  /** @deprecated Use SegmentedControl. Updated for up-to-date Canvas component */
  DeprecatedSegmentedControl: ThemedDeprecatedSegmentedControl,
  Hyperlink: ThemedHyperlink,
  Dialog: ThemedDialog,
  Skeleton: ThemedSkeleton,
  Label: ThemedLabel,
  Tooltip: ThemedTooltip,
  OverflowTooltip: ThemedOverflowTooltip,
  Pill: ThemedPill,
};
